import { render, staticRenderFns } from "./SalesReport.vue?vue&type=template&id=e15ecf1e&scoped=true&"
import script from "./SalesReport.controller.js?vue&type=script&lang=js&"
export * from "./SalesReport.controller.js?vue&type=script&lang=js&"
import style0 from "./SalesReport.vue?vue&type=style&index=0&id=e15ecf1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15ecf1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Projects/Hugo/Ilead/FrontEnd/lbcleadership/Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VFlex})
